import type { MembershipFilter } from "@/graphql/operations";

// Presentation only: never apply this to authorization or Shared Space users.
const internalDomains = ["pitchview.de", "pitchview.com", "pitchview.io"];
export const isPitchviewTeam = (tenantId: string | undefined) =>
  tenantId === "1";

export const internalTeamMemberFilter: MembershipFilter = {
  user: {
    or: internalDomains.map((domain) => ({
      email: { endsWithInsensitive: `@${domain}` },
    })),
  },
};

export function isVisibleTeamMember(
  tenantId: string | undefined,
  email: string | null | undefined,
): boolean {
  return (
    isPitchviewTeam(tenantId) ||
    !internalDomains.some((domain) =>
      email?.toLowerCase().endsWith(`@${domain}`),
    )
  );
}
